<timer [Mode]="'light'"
  *ngIf="roomdetails?.remaining_time != 0 || (!roomdetails?.remaining_time && !roomdetails?.is_closed && !roomdetails.is_me_joined && _config.getAuthUserInfo()?.user?.role_code=='General')"
  type="date" (TimerEnded)="roomdetails.remaining_time = 0" [time]="roomdetails.remaining_time" [startORend]="1">
</timer>
<div class="join m-0"
  *ngIf="(!roomdetails?.is_me_joined && !roomdetails?.is_closed)||(roomdetails?.is_me_joined  && roomdetails?.remaining_time != 0)">

  <ng-container *ngIf="!roomdetails?.is_me_joined && !roomdetails?.is_closed">
    <div class="join-txt">
      <p>{{"Auction Item.To join this auction you need to have the below amount in your wallet"|translate}}
      </p>
    </div>

    <div class="start-bid-amount">
      <p class="start-txt">{{"multiAuction.Joined Price"|translate}}</p>
      <p class="start-amount"><span>{{"Auction Item.SR"|translate}}</span> {{roomdetails.entry_fee}} </p>
    </div>

    <div class="join-btn mt-4 pb-4">

      <button (click)="onJoin()" mat-button class="btn_fill w-75">
        {{"Auction Item.join auction"|translate}}</button>
      <div class="note-join">
        {{"Auction Item.Note that once you join this auction this amount will be deducted temporarily from your
        wallet"|translate}}
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="roomdetails?.is_me_joined  && roomdetails?.remaining_time != 0">
    <div class="join-btn pb-4">
      <div class="start-bid-amount">
        <p class="start-txt">{{"multiAuction.Joined Price"|translate}}</p>
        <p class="start-amount"><span>{{"Auction Item.SR"|translate}}</span>{{roomdetails.entry_fee}}</p>
      </div>
      <div class="joined">
        <p class="joined-txt">{{"Auction Item.Joined on"|translate}}</p>
        <span class="joined-time">{{roomdetails.joined_at | dateUTC:'LL'}} {{"Auction Item.at"|translate}}
          {{roomdetails.joined_at |
          dateUTC:'h:mm:ss a'}} </span>
      </div>
      <button (click)="onWithdrawAuction()" mat-button class="btn withdraw">
        {{"Auction Item.withdraw"|translate}}</button>
    </div>
  </ng-container>

</div>